import type ThesaurusService from './thesaurus.service';

export default class ThesaurusController {

    public record;

    /*@ngInject*/
    constructor(public TEMPLATES_PATH: string,
                private thesaurusService: ThesaurusService) {
        this.loadRootRecord();
    }

    public async loadRootRecord() {
        this.record = await this.thesaurusService.getHierarchyRoot();
        await this.record.toggleRelatives();
    }

}
